/**
 * Анимация статистики на детальной матча
 */
$.fn.imagesSlider = function() {
    const $self = $(this);
    const galleryThumbContainer = $self.find('.js-gallery-thumbs').get(0);
    const galleryTopContainer = $self.find('.js-gallery-top').get(0);
    let galleryThumbs;
    let galleryTop;
    const $slides = $self.find('.js-open-popup');
    const $popup = $('.js-popup-template');
    let $nextButton = $popup.find('.js-popup-next');
    let $prevButton = $popup.find('.js-popup-prev');
    const $counter = $popup.find('.js-popup-item-count');
    let slideIndex = 0;
    const $popupImg = $popup.find('.js-popup-img');
    const defaultsGalleryParams = {
        spaceBetween: 10,
        navigation: {
            nextEl: '.js-next-slide',
            prevEl: '.js-prev-slide',
        },
        preloadImages: false,
        lazy: {
            loadPrevNext: true
        }
    };

    /**
     * Инициализация превью-слайдера
     */
    const initGalleryThumbs = () => {
        galleryThumbs = new Swiper(galleryThumbContainer, {
            spaceBetween: 28,
            slidesPerView: 6,
            freeMode: false,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            preloadImages: false,
            lazy: {
                loadPrevNext: true
            },
            breakpoints: {
                320: {
                    longSwipes: false,
                    shortSwipes: false,
                    simulateTouch: false,
                    followFinger: false,
                },
                1280: {
                    sidesPerView: 6,
                    longSwipes: false,
                    shortSwipes: false,
                    simulateTouch: true,
                    followFinger: true,
                }
            }
        });
        $self.data('galleryThumbs', galleryThumbs);
    };


    /**
     * Инициализация слайдера
     * @param {Object} [params]
     */
    const initGallery = (params) => {
        let settings = $.extend({}, defaultsGalleryParams, params);
        galleryTop = new Swiper(galleryTopContainer, settings);
        $self.data('galleryTop', galleryTop);
    };

    /**
     * Дестрой слайдера превьюх
     */
    const destroySlider = (slider) => {
        slider.destroy(true, true);
    };

    /**
     * Отслеживание ресайза
     * @param {Number} windowWidth
     */
    const lookForResize = (windowWidth) => {
        //Временно закомментировал так как на мобилке нужна превьюшка.
        // if (windowWidth < SVK.breakpoint["desktop-min"] && typeof galleryThumbs !== 'undefined') {
        //     // destroySlider(galleryThumbs);
        //     // destroySlider(galleryTop);
        //     // initGallery();
        // }
        if (windowWidth >= SVK.breakpoint["desktop-min"] && typeof galleryThumbs === 'undefined') {
            initGalleryThumbs();
            destroySlider(galleryTop);
            initGallery({thumbs: {swiper: galleryThumbs}});
        }
    };

    /**
     * Счетчик в попапе
     * @param {Number} currentIndex
     */
    const setSlidesCounter = (currentIndex) => {
        $counter.text(`${currentIndex + 1}/${$slides.length}`);
    };

    const setPopupImgAttributes = function (index) {
        const $currentSlideImg = $slides.eq(index).find('img');

        let popupSrc;
        if (typeof $currentSlideImg.data('popup-src') !== 'undefined') {
            popupSrc = $currentSlideImg.data('popup-src');
        } else if (typeof $currentSlideImg.data('src') !== 'undefined') {
            popupSrc = $currentSlideImg.data('src');
        } else {
            popupSrc = $currentSlideImg.attr('src');
        }

        $popupImg.attr({
            'src': popupSrc
        });
    };

    /**
     * Открытие попапа
     */
    const openPopup = (currentIndex) => {
        slideIndex = currentIndex;
        setSlidesCounter(slideIndex);
        setPopupImgAttributes(slideIndex);
        $('html').addClass('fixed');
        $.magnificPopup.open({
            items: {
                src: $popup,
                type: 'inline'
            },
            mainClass: 'popup--gallery',
            showCloseBtn: false
        });
    };

    /**
     * Следующий слайд в попапе
     */
    const toNextSlideInPopup = () => {
        if (slideIndex < $slides.length - 1) {
            slideIndex++;
            setSlidesCounter(slideIndex);
            setPopupImgAttributes(slideIndex);
            galleryTop.slideTo(slideIndex);
        }
    };

    /**
     * Предыдущий слайд в попапе
     */
    const toPrevSlideInPopup = () => {
        if (slideIndex > 0) {
            slideIndex--;
            setSlidesCounter(slideIndex);
            setPopupImgAttributes(slideIndex);
            galleryTop.slideTo(slideIndex);
        }
    };

    /**
     * Устанавливает блокировку на кнопку next/prev
     */
    const setDisabledButtonInPopup = function () {

        if ($slides.length === 1) {
            $nextButton.addClass('disabled');
            $prevButton.addClass('disabled');

            return;
        }

        switch (slideIndex) {
            case 0:
                $prevButton.addClass('disabled');
                $nextButton.removeClass('disabled');
                break;
            case $slides.length - 1:
                $nextButton.addClass('disabled');
                $prevButton.removeClass('disabled');
                break;
            default:
                $nextButton.removeClass('disabled');
                $prevButton.removeClass('disabled');
        }
    };

    /**
     * Инициализация ивентов
     */
    const initEvents = () => {
        $(window).on('resize load', function () {
            lookForResize(window.innerWidth);
            setDisabledButtonInPopup();
        });
        $self.on('click', '.js-open-popup', function () {
            openPopup($(this).index());
            setDisabledButtonInPopup();
        });
        $popup.on('click', function (e) {
            let $target = $(e.target);
            if ($target.is($popup) || $target.closest('.js-popup-close').length) {
                $.magnificPopup.close();
                $('html').removeClass('fixed');
            } else if ($target.closest('.js-popup-prev').length) {
                toPrevSlideInPopup();
            } else if ($target.closest('.js-popup-next').length) {
                toNextSlideInPopup();
            }

            setDisabledButtonInPopup();
        });

        $(document).on('keydown', function (e) {
            if ($(document).find($popup).length) {
                switch (e.key) {
                    case 'Escape':
                        $.magnificPopup.close();
                        $('html').removeClass('fixed');
                        break;
                    case 'ArrowLeft':
                        toPrevSlideInPopup();
                        break;
                    case 'ArrowRight':
                        toNextSlideInPopup();
                        break;
                    case ' ':
                        toNextSlideInPopup();
                        break;
                }

                setDisabledButtonInPopup();
            }
        });

        if (typeof $.fn.swipe !== 'undefined') {
            $popup.swipe({
                swipe: function (event, direction) {
                    switch (direction) {
                        case 'left':
                            toNextSlideInPopup();
                            break;
                        case 'right':
                            toPrevSlideInPopup();
                            break;
                    }

                    setDisabledButtonInPopup();
                }
            })
        }
    };

    /**
     * Инициализация
     */
    const init = () => {
        if (typeof Swiper !== 'undefined') {
            initGalleryThumbs();
            initGallery({thumbs: {swiper: galleryThumbs}});

        }
        setDisabledButtonInPopup();

        initEvents();
        $(window).trigger('resize');

    };

    init();

};
